// Action types per le notifiche
export const FETCH_NOTIFICATIONS_REQUEST = 'FETCH_NOTIFICATIONS_REQUEST';
export const FETCH_NOTIFICATIONS_SUCCESS = 'FETCH_NOTIFICATIONS_SUCCESS';
export const FETCH_NOTIFICATIONS_FAILURE = 'FETCH_NOTIFICATIONS_FAILURE';

export const MARK_NOTIFICATION_AS_READ = 'MARK_NOTIFICATION_AS_READ';
export const MARK_ALL_NOTIFICATIONS_AS_READ = 'MARK_ALL_NOTIFICATIONS_AS_READ';

export const SET_NOTIFICATIONS_SUMMARY = 'SET_NOTIFICATIONS_SUMMARY';
export const UPDATE_NOTIFICATION_COUNTS = 'UPDATE_NOTIFICATION_COUNTS';

export const CLEAR_NOTIFICATIONS = 'CLEAR_NOTIFICATIONS'; 